import { render } from "./EZUIKitJs.vue?vue&type=template&id=20bdf8ca"
import script from "./EZUIKitJs.vue?vue&type=script&lang=js"
export * from "./EZUIKitJs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__